// Import FirebaseAuth and firebase.
import firebase from 'firebase';
import React from 'react';
import { Card } from 'react-bootstrap';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';

// Configure FirebaseUI.
const uiConfig = {
  // Popup signin flow rather than redirect flow.
  signInFlow: 'popup',
  // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
  signInSuccessUrl: '/signed-in',
  // We will display Google and Facebook as auth providers.
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    // {
    //   provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    //   scopes: [
    //     'public_profile',
    //     'email',
    //   ],
    // }
  ],
};

function SignInScreen() {
  return (
    <div>
      <Card style={{ maxWidth: "500px", margin: "auto", marginTop: "100px" }}>
        <Card.Title style={{ padding: "40px" }}>Sign up or sign in here:</Card.Title>
        <Card.Body>
          <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
        </Card.Body>
      </Card>
    </div>
  );
}

export default SignInScreen
